<template>

  <modal
      id="employee-list-modal"
      v-model="showModal"
      :title="'Tenant Setup Wizard'"
      size="large"
      :close-button="isLastStep"
      :modal-backdrop="isLastStep"
  >
    <form-wizard ref="wizard" @on-complete="onComplete" :hide-buttons="true" :title="''" :subtitle="''" stepSize="sm">
      <tab-content title="Create Location" id="location">
        <default-location-create-edit-modal
            v-if="locationModal && hasLocationCreated === 0"
            v-model="locationModal"
            :selected-url="''"
            :make-default="true"
            :wizard="true"
            :data-url='LOCATION_CREATE'
            @submit="handleFormSubmit"
            @close="locationModal = false"
            ref="locationForm"
        />
        <div v-else id="wizard-tab-1">
          <app-icon :name="'map'" id="wizard-app-icon"/>
          <span>Default location already created!</span>
        </div>
      </tab-content>
      <tab-content title="Create Designation" id="designation">
        <default-designation-create-edit-modal
            v-if="designationModal && hasDesignationCreated === 0"
            v-model="designationModal"
            :selected-url="''"
            :make-default="true"
            :wizard="true"
            :data-url='apiUrl.DESIGNATION'
            @submit="handleFormSubmit"
            @close="designationModal = false"
            ref="designationForm"
        />
        <div v-else id="wizard-tab-3">
          <app-icon :name="'server'" id="wizard-app-icon"/>
          <span>Designation already created!</span>
        </div>
      </tab-content>
      <tab-content title="Create Working Shift" id="shift">
        <default-working-shift-create-edit-modal
            v-if="workingShiftModal && hasWorkingShiftCreated === 0"
            v-model="workingShiftModal"
            :selected-url="''"
            :make-default="true"
            :wizard="true"
            :data-url='apiUrl.WORKING_SHIFTS'
            @submit="handleFormSubmit"
            @close="workingShiftModal = false"
            ref="workingShiftForm"
        />
        <div v-else id="wizard-tab-4">
          <app-icon :name="'briefcase'" id="wizard-app-icon"/>
          <span>Working shift already created!</span>
        </div>
      </tab-content>
      <tab-content title="Create Department" id="department">
        <default-department-create-edit-modal
            v-if="departmentModal && hasDepartmentCreated === 0"
            v-model="departmentModal"
            :selected-url="''"
            :make-default="true"
            :wizard="true"
            :data-url='apiUrl.DEPARTMENTS'
            @submit="handleFormSubmit"
            @close="departmentModal = false"
            ref="departmentForm"
        />
        <div v-else id="wizard-tab-2">
          <app-icon :name="'home'" id="wizard-app-icon"/>
          <span>Department already created!</span>
        </div>
      </tab-content>

<!--      <tab-content title="Create Employee">
        <default-employee-create-edit-modal
            v-if="employeeModal && hasEmployeeCreated === 0"
            v-model="employeeModal"
            :selected-url="''"
            :make-default="true"
            :wizard="true"
            :data-url='apiUrl.EMPLOYEE_CREATE'
            @submit="handleFormSubmit"
            @close="employeeModal = false"
            ref="employeeForm"
        />
        <div v-else class="w-full" id="wizard-tab-5">
          <app-icon :name="'user-check'" id="wizard-app-icon"/>
          <span>Employee already created!</span>
        </div>
      </tab-content>-->
      <tab-content title="Done" class="w-full">
        <div id="wizard-tab-6">
          <app-icon :name="'check-circle'" id="wizard-app-icon"/>
          <span>Congratulations! Company setup is successful.</span>
        </div>
      </tab-content>
    </form-wizard>

    <template slot="footer">
      <!-- Footer Buttons -->
      <span @click="previousTab" v-if="!isFirstStep && !isLastStep" class="btn btn-secondary mr-3">
        Previous
      </span>
<!--      <span class="w-100">-->
<!--            <loader v-if="loading" :loader-color="'white-color'"/>-->
<!--            <template v-if="!loading">-->
<!--                {{ label }}-->
<!--            </template>-->
<!--        </span>-->
      <span @click="handleNextTab" v-if="!isLastStep" class="btn btn-primary">
        <loader v-if="loading" :loader-color="'white-color'"/>
        <template v-if="!loading">
                {{ nextButtonText }}
            </template>
<!--        {{ nextButtonText }}-->
      </span>
      <span v-if="isLastStep" @click="onComplete" class="btn btn-success" data-dismiss="modal">
        Finish
      </span>
    </template>
  </modal>


</template>

<style scoped>
.tab-content {
  width: 100% !important;
}

#location .tab-content > #app-icon,
#department .tab-content > #app-icon,
#designation .tab-content > #app-icon,
#shift .tab-content > #app-icon {
  min-width: 120px !important;
  height: auto !important;
  color: #00ACD4 !important;
  margin: auto !important;
}

/* If scoped, use deep selector to target the #app-icon's internal structure */
#location .tab-content >>> #app-icon,
#department .tab-content >>> #app-icon,
#designation .tab-content >>> #app-icon,
#shift .tab-content >>> #app-icon {
  min-width: 120px !important;
  height: auto !important;
  color: #00ACD4 !important;
  margin: auto !important;
}

/* Ensure alignment works correctly with flexbox */
.d-flex {
  display: flex !important;
}

.flex-column {
  flex-direction: column !important;
}

.align-items-center {
  align-items: center !important;
}

.justify-content-center {
  justify-content: center !important;
}
</style>


<!--<style>
.wizard-icon-container {
  background-color: #00ACD4 !important;
}
.wizard-nav > .active > .tab {
  background-color: #00ACD4 !important;
}
</style>-->

<script>
import {FormWizard, TabContent, WizardStep} from 'vue-form-wizard'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'
import ModalMixin from "../../../../common/Mixin/Global/ModalMixin";
import {TENANT_MAIL_CHECK_URL} from "../../../../common/Config/apiUrl";
import {axiosGet} from "../../../../common/Helper/AxiosHelper";
import DefaultLocationCreateEditModal from "../Location/DefaultLocationCreateEditModal";
import FormHelperMixins from "../../../../common/Mixin/Global/FormHelperMixins";
import axios from "axios";
import LocationFormValidation from "./Validation/LocationFormValidation";
import {DESIGNATION, GET_ALL_LOCATIONS, LOCATION_CREATE} from "../../../Config/ApiUrl";
import DefaultDepartmentCreateEditModal from "../Employee/Department/DefaultDepartmentCreateEditModal";
import * as apiUrl from "../../../Config/ApiUrl";
import DefaultDesignationCreateEditModal from "../Employee/Designation/DefaultDesignationCreateEditModal";
import DefaultWorkingShiftCreateEditModal from "../Adminstration/WorkingShift/DefaultWorkingShiftCreateEditModal";
// import DefaultEmployeeCreateEditModal from "../Employee/DefaultEmployeeCreateEditModal";
import Loader from "../../../../core/components/preloders/Loader";

export default {
  name: "TenantStepWizard",
  mixins: [ModalMixin, FormHelperMixins],
  components: {
    // DefaultEmployeeCreateEditModal,
    DefaultWorkingShiftCreateEditModal,
    DefaultDepartmentCreateEditModal,
    FormWizard,
    TabContent,
    WizardStep,
    DefaultLocationCreateEditModal,
    DefaultDesignationCreateEditModal,
    'loader': Loader
  },
  props: {
    value: {
      type: String,
      default: ''
    },
    makeDefault: {
      type: Boolean,
      default: false,
    },
    currentStep: {
      type: Number,
      default: 1
    },
    hasLocationCreated: {
      type: Number,
      default: 0
    },
    hasDepartmentCreated: {
      type: Number,
      default: 0
    },
    hasDesignationCreated: {
      type: Number,
      default: 0
    },
    hasWorkingShiftCreated: {
      type: Number,
      default: 0
    },
    hasEmployeeCreated: {
      type: Number,
      default: 0
    },
  },

  data() {
    return {
      loading: false,
      isMailSettingExist: false,
      isFirstStep: true,
      isLastStep: false,
      nextButtonText: 'Create Location',
      locationModal: true,
      departmentModal: true,
      designationModal: true,
      workingShiftModal: true,
      employeeModal: true,
      currentTabIndex: 0,
      LOCATION_CREATE,
    }
  },
  methods: {
    handleFormSubmit(formData) {
      // this.submitData(formData);

      // const isValid = this.$refs.locationForm.validateForm(formData);
      // if (isValid) {
      //   // Handle form submission
      //   alert('Form is valid and submitted!');
      // } else {
      //   alert('Form is invalid!');
      // }
    },
    async submitData(name, url, data) {
      // Logic to submit the data to the server
      // For example, using Axios:
      console.log(url, data);
      await axios.post(url, data)
          .then(response => {
            this.loading = false;
            console.log(`${name} created successfully:`, response.data);
            this.toastAndReload(response.data.message);
            if (this.$refs.wizard.activeTabIndex === 0) {
              this.hasLocationCreated = 1;
              this.nextTab('Create Designation');
            } else if (this.$refs.wizard.activeTabIndex === 1) {
              this.hasDesignationCreated = 1;
              this.nextTab('Create Working Shift');
            } else if (this.$refs.wizard.activeTabIndex === 2) {
              this.hasWorkingShiftCreated = 1;
              this.nextTab('Create Department');
            } else if (this.$refs.wizard.activeTabIndex === 3) {
              this.hasDepartmentCreated = 1;
              this.nextTab('Finish');
              this.isLastStep = true;
              // this.nextTab('Create Employee');
            }
            // else if (this.$refs.wizard.activeTabIndex === 4) {
            //   this.nextTab('Finish');
            //   this.hasEmployeeCreated = 1;
            //   this.isLastStep = true;
            // }

            // Handle success
            return true;
          })
          .catch(error => {
            this.loading = false;
            console.log(`Error creating ${name}:`, error.response.data.message);
            if (this.$refs.wizard.activeTabIndex === 4) {
              // this.$refs.employeeForm.setServerErrors(error.errors);
            }
            return error;
            // Handle error
          });
    },
    onTabChange(oldIndex, newIndex) {
      this.currentTabIndex = newIndex;  // Update the current tab index
      this.isFirstStep = newIndex === 0;
      this.isLastStep = newIndex === this.$refs.wizard.tabs.length - 1;
    },
    onSubmitLocation(payload) {
      console.log("Location submitted: ", payload.locationData);
    },
    onLocationCreated() {
      // Move to the next tab when location is successfully created
      // this.nextTab();
    },
    async handleNextTab() {
      if (this.$refs.wizard.activeTabIndex === 0) {
        if (this.hasLocationCreated === 1) {
          this.nextTab('Create Designation');
        } else {
          this.loading = true;
          // Get the form data from the location form
          const formData = this.$refs.locationForm.getFormData();

          console.log(this.$refs.locationForm, formData);
          // Validate the form data
          const isValid = this.$refs.locationForm.validateForm(formData);

          if (isValid) {
            await this.submitData('Location', LOCATION_CREATE, formData);
          } else {
            // Handle validation failure (e.g., show error messages)
            console.log("Form is invalid");
          }
        }
      } else if (this.$refs.wizard.activeTabIndex === 1) {
        if (this.hasDesignationCreated === 1) {
          this.nextTab('Create Working Shift');
          // this.$refs.designationForm.getDesignations();
        } else {
          this.loading = true;
          const formData = this.$refs.designationForm.getFormData();
          console.log(formData);
          const isValid = this.$refs.designationForm.validateForm(formData);

          if (isValid) {
            if (this.hasDepartmentCreated === 0) await this.submitData('Designation', apiUrl.DESIGNATION, formData);
            this.$refs.workingShiftForm.getLocations();
          } else {
            this.loading = false;
            // Handle validation failure (e.g., show error messages)
            console.log("Form is invalid");
          }
        }
      } else if (this.$refs.wizard.activeTabIndex === 2) {
        if (this.hasWorkingShiftCreated === 1) {
          this.nextTab('Create Department');
        } else {
          this.$refs.workingShiftForm.getLocations();
          this.loading = true;
          const formData = this.$refs.workingShiftForm.getFormData();
          console.log(formData);
          const isValid = this.$refs.workingShiftForm.validateForm(formData);

          if (isValid) {
            await this.submitData('Working Shift', apiUrl.WORKING_SHIFTS, formData);
            if (this.hasDepartmentCreated === 0) this.$refs.departmentForm.getWorkingShifts();
          } else {
            // Handle validation failure (e.g., show error messages)
            console.log("Form is invalid");
          }
        }
      } else if (this.$refs.wizard.activeTabIndex === 3) {
        if (this.hasDepartmentCreated === 1) {
          this.nextTab('Done');
          this.isLastStep = true;
        } else {
          this.loading = true;
          const formData = this.$refs.departmentForm.getFormData();
          console.log(formData);
          const isValid = this.$refs.departmentForm.validateForm(formData);

          if (isValid) {
            await this.submitData('Department', apiUrl.DEPARTMENTS, formData);
          } else {
            // Handle validation failure (e.g., show error messages)
            console.log("Form is invalid");
          }
        }
      } else if (this.$refs.wizard.activeTabIndex === 4) {
        if (this.hasEmployeeCreated === 1) {
          this.hasEmployeeCreated = 1;
          this.isLastStep = true;
          this.nextTab('Done');
        } else {
          this.loading = true;
          const formData = this.$refs.employeeForm.getFormData();
          console.log(formData);
          const isValid = this.$refs.employeeForm.validateForm(formData);

          if (isValid) {
            let created = await this.submitData('Employee', apiUrl.EMPLOYEE_CREATE, formData);
            if (created) {
              this.hasEmployeeCreated = 1;
              console.log(data);
            }
          } else {
            // Handle validation failure (e.g., show error messages)
            console.log("Form is invalid");
          }
        }
      }
    },
    nextTab(tab = '') {
      this.$nextTick(() => {
        if (this.$refs.wizard) {
          this.$refs.wizard.nextTab();  // Ensure the ref is available
          this.isFirstStep = false;
          this.nextButtonText = tab ?? 'Create Location';
        }
      });
    },
    previousTab() {
      console.log(this.$refs.wizard.activeTabIndex);
      this.$nextTick(() => {
        if (this.$refs.wizard) {
          this.$refs.wizard.prevTab();  // Ensure the ref is available
          if (this.$refs.wizard.activeTabIndex === 1) {
            this.nextButtonText = 'Create Location';
          } else if (this.$refs.wizard.activeTabIndex === 2) {
            this.nextButtonText = 'Create Designation';
          } else if (this.$refs.wizard.activeTabIndex === 3) {
            this.nextButtonText = 'Create Working Shift';
          } else if (this.$refs.wizard.activeTabIndex === 4) {
            this.nextButtonText = 'Create Department';
          }
        }
      });
    },
    checkMailSettings() {
      this.preloader = true;
      axiosGet(TENANT_MAIL_CHECK_URL).then(response => {
        this.isMailSettingExist = !!response.data;
      }).finally(() => {
        this.preloader = false;
      });
    },
    fetchLocations() {
      this.preloader = true;
      axiosGet(GET_ALL_LOCATIONS).then(response => {
        this.isMailSettingExist = !!response.data;
      }).finally(() => {
        this.preloader = false;
      });
    },
    onComplete() {
    }
  },
  created() {
    this.checkMailSettings();
  },
  computed: {},
  mounted() {
    console.log(this.currentStep);
    this.currentTabIndex = this.currentStep;
  },
}

</script>

